var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMv2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 182,
    viewBox: "0 0 200 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3952 0H161.605C171.776 0.0385844 181.52 4.09617 188.712 11.2883C195.904 18.4805 199.961 28.224 200 38.3952V142.822C200.009 152.988 195.981 162.741 188.802 169.938L188.444 170.264C181.299 177.271 171.694 181.203 161.686 181.217H38.3952C33.3556 181.214 28.3662 180.216 23.7131 178.28C19.06 176.345 14.8347 173.51 11.2793 169.938L10.9538 169.58C3.93624 162.441 0.00266151 152.833 0 142.822L0 38.3952C0.0300557 28.2214 4.0849 18.4729 11.2789 11.2789C18.4729 4.0849 28.2214 0.0300557 38.3952 0ZM11.9629 43.0827H34.7494L49.4954 11.9629H38.3952C31.3915 11.9844 24.6808 14.7761 19.7284 19.7284C14.7761 24.6808 11.9844 31.3915 11.9629 38.3952V43.0827ZM60.3027 11.9629L45.5729 43.0827H86.849L101.611 12.0117L60.3027 11.9629ZM112.386 11.9629L97.526 43.0827H137.728L152.507 11.9629H112.386ZM163.363 11.9629L148.535 43.0827H188.037V38.3952C188.008 31.6861 185.441 25.2366 180.851 20.3424C176.262 15.4483 169.991 12.4721 163.298 12.0117L163.363 11.9629ZM188.102 55.3874H11.9629V142.822C11.9899 149.705 14.7059 156.306 19.5312 161.214L19.8079 161.475C24.7257 166.434 31.4111 169.238 38.3952 169.271H161.605C168.477 169.266 175.075 166.579 179.997 161.784L180.257 161.491C182.719 159.048 184.674 156.142 186.009 152.941C187.344 149.74 188.033 146.307 188.037 142.839V55.4362L188.102 55.3874Z",
    fill: "#80E614"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_13"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 181.217,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMv2);
export default __webpack_public_path__ + "static/media/mv2.ea2aea6a2c0d6ecd740c0b66876e370f.svg";
export { ForwardRef as ReactComponent };